<div class="email">
  <app-popup-top-line></app-popup-top-line>
  <div class="email-header">
    <div class="title">Send Email</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="email-body">
    <form class="form-style" [formGroup]="fg">
      <div class="input-title">To</div>
      <div
        style="width: 150px"
        [matTooltip]="contactMakerTooltip"
        matTooltipPosition="above"
        matTooltipClass="tooltip-container"
      >
        <mat-checkbox
          color="primary"
          [disabled]="this.emailData.resourceMakerEmails.size === 0"
          [checked]="contactMakerChecked"
          (change)="onContactMakerChange()"
        >
          {{ 'commonActions.sendEmailAction.contactMaker' | labelsProvider }}
        </mat-checkbox>
      </div>
      <div
        class="input"
        [ngClass]="{
          'input-invalid': fg.controls['to'].invalid && (fg.controls['to'].dirty || fg.controls['to'].touched),
        }"
      >
        <input type="text" formControlName="to" placeholder="Enter emails, separate with , or ;" />
      </div>
      <div class="input-title">Subject</div>
      <div
        class="input"
        [ngClass]="{
          'input-invalid':
            fg.controls['subject'].invalid && (fg.controls['subject'].dirty || fg.controls['subject'].touched),
        }"
      >
        <input type="text" formControlName="subject" placeholder="Enter subject" />
      </div>
      <div class="input-title">Body</div>
      <div
        class="textarea"
        [ngClass]="{
          'textarea-invalid': fg.controls['body'].invalid && (fg.controls['body'].dirty || fg.controls['body'].touched),
        }"
      >
        <textarea type="text" formControlName="body" placeholder="Enter text"></textarea>
      </div>
      <div class="input-title">
        Available Labels
        <img
          class="info"
          src="assets/images/notifications/info.svg"
          alt="info"
          matTooltip="Text labels will be replaced with the relevant values in the email body and subject"
          matTooltipPosition="above"
          matTooltipClass="tooltip-container"
        />
      </div>
      <div class="placeholders">
        <div *ngFor="let placeholder of supportedEmailPlaceholders">
          <p>
            <kbd>{{ placeholder.label }}</kbd>
            {{ placeholder.description }}
          </p>
        </div>
      </div>
    </form>
  </div>
  <div class="email-footer">
    <button class="cancel" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button
      class="confirm"
      [ngClass]="{ 'confirm-disabled': fg.invalid || waitingForResponse }"
      (click)="sendEmail()"
      cdkFocusInitial
    >
      <span *ngIf="!waitingForResponse">Send</span>
      <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </button>
  </div>
</div>
